import type { SupportedLanguage } from '../i18n';

// Returns the value of `${fieldBaseName}_zh` on `entity` when `language` is
// 'zh' and that value is present (non-null, non-empty after trimming).
// Otherwise falls back to the English field `entity[fieldBaseName]`.
//
// Generic over `T` so this works for any entity shape (Category, Product,
// ProductSize, BubbleTeaMenuItem, etc.) without needing a union of every
// entity type here — callers pass whichever object they have.
//
// Constrained to `object` rather than `Record<string, unknown>`: none of the
// real entity interfaces in this codebase (Product, Category, CakeOptionItem,
// etc.) declare a string index signature, so a `Record<string, unknown>`
// constraint would reject every concrete caller and only accept ad-hoc object
// literals. The field lookups below go through a local `Record<string,
// unknown>` cast instead, which keeps the same dynamic-key behavior.
export function getLocalizedField<T extends object>(
  entity: T,
  fieldBaseName: string,
  language: SupportedLanguage
): unknown {
  const record = entity as Record<string, unknown>;

  if (language === 'zh') {
    const zhValue = record[`${fieldBaseName}_zh`];
    if (typeof zhValue === 'string') {
      if (zhValue.trim() !== '') {
        return zhValue;
      }
    } else if (zhValue !== null && zhValue !== undefined) {
      return zhValue;
    }
  }

  return record[fieldBaseName];
}
